import React, { ReactNode } from 'react';
import { Radio } from '@grubhubprod/gh-cookbook-react';
import {
  Control,
  RegisterOptions,
  useController,
  useWatch,
} from 'react-hook-form';

interface CookbookRadioWrapperProps {
  name: string;
  control: Control;
  disabled?: boolean;
  rules?: RegisterOptions;
  label: ReactNode;
  value: string;
  id: string;
}
export const CookbookRadioWrapper = ({
  name,
  control,
  rules = {},
  label,
  value,
  ...cookbookRadioProps
}: CookbookRadioWrapperProps): JSX.Element => {
  const { field } = useController({
    name,
    rules,
    control,
    defaultValue: control.defaultValuesRef.current[name] ?? '',
  });

  const watchedValue = useWatch({
    control,
    name,
  });

  const onChange = (): void => {
    field.onChange(value);
  };

  return (
    <Radio
      {...field}
      {...cookbookRadioProps}
      onChange={onChange}
      checked={watchedValue === value}
      value={value}
    >
      {label}
    </Radio>
  );
};
